var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinSquareStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 64C36.6569 64 38 65.3431 38 67C38 68.6569 36.6569 70 35 70C33.3431 70 32 68.6569 32 67C32 65.3431 33.3431 64 35 64ZM35 66C34.4477 66 34 66.4477 34 67C34 67.5523 34.4477 68 35 68C35.5523 68 36 67.5523 36 67C36 66.4477 35.5523 66 35 66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 2C59.3137 2 62 4.68629 62 8V50C62 53.3137 59.3137 56 56 56H46C41.0001 56 38.75 56.4444 37.25 59.4072C37.1039 59.6957 36.9791 59.9706 36.8633 60.2256C36.3843 61.2796 36.0568 62 35 62C33.9432 62 33.6157 61.2796 33.1367 60.2256C33.0209 59.9706 32.8961 59.6957 32.75 59.4072C31.25 56.4444 28.9999 56 24 56H14C10.6863 56 8 53.3137 8 50V8C8 4.68629 10.6863 2 14 2H56ZM14 5C12.3431 5 11 6.34315 11 8V50C11 51.6569 12.3431 53 14 53H56C57.6569 53 59 51.6569 59 50V8C59 6.34315 57.6569 5 56 5H14Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinSquareStroke);
export default __webpack_public_path__ + "static/media/map_pin_square_stroke.16e103c50425c25ddf2d819f1d54d8b6.svg";
export { ForwardRef as ReactComponent };